import React, { useEffect, useState, useContext } from 'react'
import { observer } from 'mobx-react'
import { useHistory } from 'react-router'
import QrScanner from 'qr-scanner'
import { Link } from 'react-router-dom'
import { XIcon } from '@heroicons/react/outline'
import { topBarStore } from '../../../lib/stores/TopBarStore'
import StoreContext from '../../providers/storesContext'
import deviceIsMobile from '../../../lib/util/device-is-mobile'
import ServerError from '../../../lib/components/ServerError'
import { caseDetailUrl, HOME } from '../../routing/paths'
import ScanSearchStore from './ScanSearchStore'

const ScanSearch = (props) => {
  const [scanSearchStore] = useState(() => new ScanSearchStore())
  const { caseDetailStore } = useContext(StoreContext)
  const history = useHistory()

  const handleScanQR = (result) => {
    scanSearchStore.search(result).then((response) => {
      if (response !== false) {
        caseDetailStore.setCase(response)
        caseDetailStore.setBillsLoaded(true)
        history.push(caseDetailUrl(response))
      }
    })
  }

  useEffect(() => {
    if (props.location.state) {
      scanSearchStore.setErrors(props.location.state.errorLoad)
      history.replace()
      caseDetailStore.clearCaseLoadError()
    }

    if (deviceIsMobile()) {
      QrScanner.WORKER_PATH = '/js/qr-scanner-worker.min.js'

      const videoElem = document.getElementById('qr-video')
      const qrScanner = new QrScanner(videoElem, handleScanQR)

      qrScanner.start().catch((error) => {
        const errors = document.createElement('div')
        errors.innerHTML = error
        errors.style.color = 'red'

        videoElem.insertAdjacentElement('afterend', errors)
      })

      // There is absoultely no way this is the best way to show only the camera
      // where the qr scan is active, but it works for now at least
      qrScanner.$canvas.classList.add('qr-reader')
      qrScanner.$canvas.style.maxWidth = '100%'
      videoElem.insertAdjacentElement('afterend', qrScanner.$canvas)
      videoElem.style.display = 'none'

      const action = (
        <Link to={HOME}>
          <XIcon className="h-6 w-6" />
        </Link>
      )

      topBarStore.setActionIcon(action)

      return () => {
        scanSearchStore.clearErrors()
        topBarStore.reset()
        qrScanner.stop()
      }
    } else {
      history.push(HOME)
    }
  }, [])

  return (
    <div className="flex flex-col items-center">
      <div className="font-bold mt-4">Place the qr code inside the area</div>
      <div className="text-gray-500 my-4">Scanning will start automatically</div>
      <div>
        <video id="qr-video" width="100%" />
      </div>
      {scanSearchStore.error && (
        <div className="mt-8 w-full">
          <ServerError message={scanSearchStore.error} />
        </div>
      )}
    </div>
  )
}

export default observer(ScanSearch)
